import httpUtil from "../assets/script/utils/http";

const state = {
  history: [],
  acticledetail: "",
  article: {
    list: [],
    rowCount: 0,
    realCount: 0
  },
  paragraph: {
    list: [],
    rowCount: 0
  },
  longword: {
    list: [],
    rowCount: 0
  },
  picture: {
    list: [],
    rowCount: 0
  },
  frequency: {
    list: [],
    rowCount: 0,
    dataCount: 0
  },
  searcharticle: {
    list: [],
    rowCount: 0,
    realCount: 0
  },
  oldKeyWords: "",
  oldTagWords: "",
  oldParagraph: "",
  oldLongWords: "",
  oldFrequency: "",
  oldPic: ""
};

const mutations = {
  setSearchKeyword(state, payload) {
    state.keyword = payload.keyword;
  },
  setArticlelist(state, payload) {
    state.article.list = payload.list;
    state.article.rowCount = payload.rowCount;
    if (payload.realCount) {
      state.article.realCount = payload.realCount;
    }
  },
  setSearchArticlelist(state, payload) {
    state.searcharticle.list = payload.list;
    state.searcharticle.rowCount = payload.rowCount;
    if (payload.realCount) {
      state.searcharticle.realCount = payload.realCount;
    }
  },
  setHistory(state, payload) {
    state.history.push(payload);
  },
  setActicledetail(state, payload) {
    state.acticledetail = payload;
  },
  setParagraph(state, payload) {
    state.paragraph.list = payload.list;
    state.paragraph.rowCount = payload.rowCount;
  },
  setLongWord(state, payload) {
    state.longword.list = payload.list;
    state.longword.rowCount = payload.rowCount;
  },
  setPicture(state, payload) {
    state.picture.list = payload.list;
    state.picture.rowCount = payload.rowCount;
  },
  setFrequency(state, payload) {
    state.frequency.list = payload.list;
    state.frequency.rowCount = payload.rowCount;
    if (payload.dataCount) {
      state.frequency.dataCount = payload.dataCount;
    }
  },
  setOldKeyWords(state, words) {
    state.oldKeyWords = words;
  },
  setOldTagWords(state, words) {
    state.oldTagWords = words;
  },
  setOldParagraph(state, words) {
    state.oldParagraph = words;
  },
  setOldLongWords(state, words) {
    state.oldLongWords = words;
  },
  setOldFrequency(state, words) {
    state.oldFrequency = words;
  },
  setOldPic(state, words) {
    state.oldPic = words;
  }
};

const actions = {
  //高频词插入任务
  AFrequencyTask(ctx, params) {
    return httpUtil.post("/ai/FrequencyTask", params);
  },
  //获取进度
  AFrequencyList(ctx, params) {
    return httpUtil.post("/ai/FrequencyList", params);
  },
  //获取进度
  AFrequencyProgress(ctx, params) {
    return httpUtil.post("/ai/FrequencyProgress", params);
  },
  // 获取词频
  AWord(ctx, params) {
    return httpUtil.post("/WordCloud/Word", params);
  },
  //插入任务
  AwordInsert(ctx, params) {
    return httpUtil.post("/WordCloud/wordInsert", params);
  },
  //获取摘要byGuid
  AAbstract(ctx, params) {
    return httpUtil.post("/Abstract/Abstract", params);
  },
  getArticleEssences(ctx, params) {
    return httpUtil.post("/ai/ArticleEssences", params);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
